
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import MissionValues from './about/MissionValues';
import StatsGrid from './about/StatsGrid';
import TrustIndicators from './about/TrustIndicators';
import Timeline from './about/Timeline';
import InnovationHighlights from './about/InnovationHighlights';

const AboutSection = () => {
  return (
    <section id="about" className="bg-white section-padding">
      <div className="container mx-auto container-padding">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold gradient-text mb-4">
            About Truecore
          </h2>
          <p className="text-lg text-muted-foreground">
            For 25 years, we've been crafting custom technology solutions for clients worldwide.
            Our team of engineers, designers, and tech enthusiasts are dedicated to building tools that solve real problems.
          </p>
        </div>

        <MissionValues />
        <StatsGrid />

        <div className="my-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="tech-card p-6 hover:scale-105 transition-all cursor-pointer">
            <div className="h-48 mb-4 rounded bg-gradient-to-br from-primary/5 to-primary/10 flex items-center justify-center">
              <img 
                src="/lovable-uploads/6969329d-32df-4dfe-af50-a3e05b322a43.png" 
                alt="Custom Tablets" 
                className="max-h-40 rounded shadow-lg"
              />
            </div>
            <h3 className="text-xl font-semibold mb-2">Custom Tablets</h3>
            <p className="text-muted-foreground mb-4">
              Rugged, reliable tablets built for industry-specific needs with extended battery life and enhanced durability.
            </p>
            <Link to="/product/tablets" className="text-primary flex items-center group">
              Learn more 
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          
          <div className="tech-card p-6 hover:scale-105 transition-all cursor-pointer">
            <div className="h-48 mb-4 rounded bg-gradient-to-br from-accent/5 to-accent/10 flex items-center justify-center">
              <img 
                src="https://images.unsplash.com/photo-1593640495253-23196b27a87f?w=400&auto=format&fit=crop" 
                alt="Custom PCs" 
                className="max-h-40 rounded shadow-lg"
              />
            </div>
            <h3 className="text-xl font-semibold mb-2">Custom PCs</h3>
            <p className="text-muted-foreground mb-4">
              High-performance computing solutions designed for specialized applications and demanding workloads.
            </p>
            <Link to="/product/pcs" className="text-primary flex items-center group">
              Learn more 
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          
          <div className="tech-card p-6 hover:scale-105 transition-all cursor-pointer">
            <div className="h-48 mb-4 rounded bg-gradient-to-br from-secondary/5 to-secondary/10 flex items-center justify-center">
              <img 
                src="https://images.unsplash.com/photo-1591405351990-4726e331f141?w=400&auto=format&fit=crop" 
                alt="Custom Desktops" 
                className="max-h-40 rounded shadow-lg"
              />
            </div>
            <h3 className="text-xl font-semibold mb-2">Custom Desktops</h3>
            <p className="text-muted-foreground mb-4">
              Enterprise-grade desktop solutions with robust security features and custom configurations.
            </p>
            <Link to="/product/desktops" className="text-primary flex items-center group">
              Learn more 
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

        <TrustIndicators />
        <Timeline />
        <InnovationHighlights />
      </div>
    </section>
  );
};

export default AboutSection;
